import * as RadixLabel from '@radix-ui/react-label';
import type { ComponentPropsWithoutRef } from 'react';

import { cn } from '../../lib/utils';

export function Label({ className, ...props }: ComponentPropsWithoutRef<typeof RadixLabel.Root>) {
  return <RadixLabel.Root className={cn('text-sm font-medium text-text', className)} {...props} />;
}
